module.exports = __webpack_public_path__ + "static/media/pic03.c9b81d70.png";